<template>
  <div class="fs14 flex-baseline lh2" :class="{[params.className]: !!params.className}" v-if="params.key!='miAccuseLogVo'" >
    <p class="c0-5 w70 textRight mr8">{{params.label}}:</p>
    <template v-if="params.filters === 'filterBrandName'">
      <span class="c0-65">{{rowData[params.key] | filterBrandName(brands)}}</span>
    </template>
    <template v-else-if="params.filters === 'filterStatus'">
      <span class="c0-65">{{rowData[params.key] | filterStatus}}</span>
    </template>
    <template v-else-if="params.filters === 'filterStatus3'">
      <span class="c0-65">{{rowData[params.key] | filterStatus3}}</span>
    </template>
        <template v-else-if="params.filters === 'filterStatus4'">
      <span class="c0-65">{{rowData[params.key] | filterStatus4}}</span>
    </template>
      <template v-else-if="params.filters === 'filterMoldStatus'">
      <span class="c0-65">{{rowData[params.key] | filterMoldStatus}}</span>
    </template>
    <template v-else-if="params.filters === 'dateFormat'">
      <span class="c0-65">{{rowData[params.key] | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
    </template>
    <template v-else-if="params.filters === 'filterAccuseTypes'">
      <span class="c0-65">{{rowData[params.key] | filterAccuseTypes(replyTypeList)}}</span>
    </template>
    <template v-else-if="params.filters === 'getInvestigateName'">
      <span class="c0-65">{{rowData[params.key] | getInvestigateName}}</span>
    </template>
     <template v-else-if="params.filters === 'memo'">
      <span class="c0-65 red">{{'-'+rowData[params.key] }}</span>
    </template>
    <template v-else-if="params.filters === 'filterRuleConfig'">
      <span class="c0-65 red">{{rowData[params.key]| filterRuleConfig }}</span>
    </template>
    <template v-else-if="params.key === 'submitName'||params.key === 'reportName'">
      <span class="c0-65">{{params.value?params.value:rowData[params.key]}}</span>
     <span class="pu" v-if='rowData.isSupervise'>监</span>
    </template>
    <template v-else>
      <span class="c0-65">{{params.value?params.value:rowData[params.key]}}</span>
    </template>
  </div>
  <div v-else >
    <template v-for="item in miAccuseLogVo" >
      <div class="fs14 flex-baseline lh2">
        <p class="c0-5 w70 textRight mr8">整改时间:</p>
        <span class="c0-65">{{item.createTime| dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
      </div>
       <div class="fs14 flex-baseline lh2" v-if='item.time>0'>
        <p class="c0-5 w70 textRight mr8">整改时长:</p>
        <span class="c0-65">{{item.time}}分钟</span>
      </div>
       <v-image :rowData='{miAccuseLogVo:item.pictures}' :params='params' :class="item.status!='整改'?'':'mb24'"></v-image>
       <div class="fs14 flex-baseline lh2 mb24" v-if="item.status!='整改'">
        <p class="c0-5 w70 textRight mr8">核查结果:</p>
        <span class="c0-65">{{item.status}}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import filters from '../filters.js'
import vImage from "./v-image";

export default {
  name: 'v-text',
  props: ['params', 'rowData'],
  components:{vImage},
  filters,
  computed: {
    ...mapGetters([
      'brands',
      'replyTypeList'
    ]),
    miAccuseLogVo() {
      if (this.params && this.params.key=='miAccuseLogVo') {
        const arr = [];
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.rowData.miAccuseLogVo = this.rowData.miAccuseLogVo || this.rowData.miExamineLogVos ||[];
        this.rowData.miAccuseLogVo.forEach((val) => {
          // 如果val 是 整改 那就push  不是整改 那就替换上一条
          if (val.auditCurrent == 1 && val.applyStatus == 2) {
            val.status = "整改"
            arr.push(val);
          } else {
            if (val.auditCurrent == 2 && val.applyStatus == 1) {
              val.status = "不合格";
              let aa = arr.splice(-1, 1, val);
              arr[arr.length - 1].pictures = aa[0].pictures;
              arr[arr.length - 1].createTime = aa[0].createTime;
              arr[arr.length - 1].time = Math.round((new Date(val.createTime)-new Date(aa[0].createTime))/60/1000)
            }
            if (val.auditCurrent == 2 && val.applyStatus == 3) {
              val.status = "合格";
              let aa = arr.splice(-1, 1, val);
              arr[arr.length - 1].pictures = aa[0].pictures;
              arr[arr.length - 1].createTime = aa[0].createTime;
              arr[arr.length - 1].time = Math.round((new Date(val.createTime)-new Date(aa[0].createTime))/60/1000)
            }
          }
        })
        return arr
      } else {
        return []
      }
    }
  }
}
</script>

<style lang="less">
@import "../../../styles/index.less";
</style>

<style lang="less" scoped>
.pu{
  margin-left: 5px;
}
.red{
  color: #ED462F;
}
</style>
